import {ChatRoom, ChatRoomMessage} from "@/models/chat.model.ts";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {uuid} from "@/interfaces";

interface State {
    list: ChatRoom[];
    totalUnreadCount: number;
}

const initialState: State = {
    list: [],
    totalUnreadCount: 0
};

const slice = createSlice({
    name: "messages",
    initialState,
    reducers: {
        upsertRoom(state, action: PayloadAction<ChatRoom>) {
            const idx = state.list.findIndex(r => r.id === action.payload.id);
            if (idx > -1)
                state.list[idx] = action.payload;
            else
                state.list.push(action.payload);
        },

        setRooms(state, action: PayloadAction<ChatRoom[]>) {
            state.list = action.payload;
        },

        touchRoom(state, action: PayloadAction<{ roomId: uuid; last: ChatRoomMessage }>) {
            const idx = state.list.findIndex(r => r.id === action.payload.roomId);
            if (idx === -1) return;
            state.list[idx].last_message_data = [action.payload.last];
            state.list[idx].updated_at        = action.payload.last.created_at;

            const [room] = state.list.splice(idx, 1);
            state.list.unshift(room);
        },

        updateUnreadCount: (state, { payload: { roomId, count } }: PayloadAction<{ roomId: uuid; count: number }>) => {
            const r = state.list.find(r => r.id === roomId)
            if (r) r.unread_count = count
            // Recalculate total unread count
            state.totalUnreadCount = state.list.reduce((total, room) => total + (room.unread_count || 0), 0);
        },

        setTotalUnreadCount: (state, action: PayloadAction<number>) => {
            state.totalUnreadCount = action.payload;
        },

        setRoomsWithUnreadUpdate: (state, action: PayloadAction<ChatRoom[]>) => {
            state.list = action.payload;
            // Recalculate total unread count when rooms are set
            state.totalUnreadCount = action.payload.reduce((total, room) => total + (room.unread_count || 0), 0);
        }
    }
});

export const {upsertRoom, setRooms, touchRoom, updateUnreadCount, setTotalUnreadCount, setRoomsWithUnreadUpdate} = slice.actions;
export default slice.reducer;